import { LayoutClasses } from './NextBestActivities.enums';

export function getLayoutClass(length: number): string {
  if (length === 3) {
    return LayoutClasses.layout3Col;
  } else if (length === 4) {
    return LayoutClasses.layout4Col;
  } else if (length >= 5 && length <= 6) {
    return LayoutClasses.layout5pCol;
  } else {
    return 'owc-nba--unsupportedLength';
  }
}
